/* VV · Utilidades globales: ventanas de fechas de campañas, cuentas atrás y barra de anuncios rotativa. */
(function () {
  'use strict';
  if (window.VVGlobal) return;
  window.VVGlobal = true;

  function parse(v) {
    var t = Date.parse(v || '');
    return isNaN(t) ? null : t;
  }
  function setText(el, v) {
    if (el && el.textContent !== v) el.textContent = v;
  }
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Muestra u oculta los elementos según su ventana de fechas (hora del navegador). */
  function applyWindows(root) {
    var now = Date.now();
    root.querySelectorAll('[data-vv-from],[data-vv-until]').forEach(function (el) {
      var f = parse(el.getAttribute('data-vv-from'));
      var u = parse(el.getAttribute('data-vv-until'));
      var on = (f === null || now >= f) && (u === null || now <= u);
      if (el.hasAttribute('data-vv-invert')) on = !on;
      el.hidden = !on;
    });
  }

  /* Cuentas atrás reales hasta la fecha indicada en data-vv-countdown.
     Si no hay casilla de días, las horas son las totales (p. ej. 29 : 30 : 00). */
  function updateCountdowns(root) {
    var now = Date.now();
    root.querySelectorAll('[data-vv-countdown]').forEach(function (el) {
      var end = parse(el.getAttribute('data-vv-countdown'));
      if (end === null) return;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      var dEl = el.querySelector('[data-d]');
      var hEl = el.querySelector('[data-h]');
      if (hEl) {
        if (dEl) setText(dEl, pad(d));
        setText(hEl, pad(dEl ? h : Math.floor(s / 3600)));
        setText(el.querySelector('[data-m]'), pad(m));
        setText(el.querySelector('[data-s]'), pad(sec));
      } else if (el.getAttribute('data-vv-format') === 'hms') {
        setText(el, pad(Math.floor(s / 3600)) + 'H ' + pad(m) + 'M ' + pad(sec) + 'S');
      } else {
        setText(el, (d > 0 ? d + 'D ' : '') + pad(h) + 'H ' + pad(m) + 'M');
      }
    });
  }

  /* Barra de anuncios: un mensaje cada vez, cambio automático, pausa al pasar el ratón o enfocar. */
  function initAnnouncements(root) {
    root.querySelectorAll('.vv-ann').forEach(function (bar) {
      if (bar.dataset.vvInit) return;
      bar.dataset.vvInit = '1';
      var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
      var idx = 0;
      var timer = null;
      var paused = false;
      function list() {
        return Array.prototype.filter.call(bar.querySelectorAll('.vv-ann__msg'), function (m) {
          return !m.hidden;
        });
      }
      function show(i) {
        var items = list();
        bar.classList.toggle('is-single', items.length < 2);
        if (!items.length) return;
        idx = (i + items.length) % items.length;
        bar.querySelectorAll('.vv-ann__msg').forEach(function (m) {
          m.classList.remove('is-active');
          m.setAttribute('aria-hidden', 'true');
        });
        items[idx].classList.add('is-active');
        items[idx].setAttribute('aria-hidden', 'false');
      }
      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          if (!paused) show(idx + 1);
        }, speed);
      }
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      var prev = bar.querySelector('[data-vv-prev]');
      var next = bar.querySelector('[data-vv-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { show(idx + 1); start(); });
      show(0);
      start();
    });
  }

  function run(root) {
    root = root || document;
    applyWindows(root);
    updateCountdowns(root);
    initAnnouncements(root);
  }

  function boot() {
    run(document);
    setInterval(function () { updateCountdowns(document); }, 1000);
    /* Re-evaluar fechas cada minuto (por si la página lleva tiempo abierta). */
    setInterval(function () { applyWindows(document); }, 60000);
    /* Contenido que llega más tarde (p. ej. productos relacionados). */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        applyWindows(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
